import { RegisteredComponent } from "@builder.io/sdk-react";

export const itsmWrapperBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "ITSMWrapper",
  noWrap: true,
  canHaveChildren: true,
  shouldReceiveBuilderProps: {
    builderContext: true,
    builderBlock: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  inputs: [
    {
      name: "tableView",
      friendlyName: "Table View",
      helperText: "Content shown when in table view (interactive table + form)",
      type: "uiBlocks",
      defaultValue: [
        {
          "@type": "@builder.io/sdk:Element",
          component: {
            label: "Table View",
            name: "Core:Section",
            options: {
              maxWidth: 1280,
            },
          },
          children: [
            {
              "@type": "@builder.io/sdk:Element",
              component: {
                name: "Maturity Model",
              },
            },
          ],
        },
      ],
    },
    {
      name: "confirmationView",
      friendlyName: "Confirmation View",
      helperText:
        "Content shown when in confirmation view (PDF buttons + image)",
      type: "uiBlocks",
      defaultValue: [
        {
          "@type": "@builder.io/sdk:Element",
          component: {
            label: "Confirmation View",
            name: "Core:Section",
            options: {
              maxWidth: 1280,
            },
          },
          responsiveStyles: {
            large: {
              paddingTop: "64px",
              paddingBottom: "64px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "32px",
            },
          },
          children: [
            {
              "@type": "@builder.io/sdk:Element",
              component: {
                name: "Text",
                options: {
                  text: "<h1>Email sent! Check your inbox</h1>",
                },
              },
              responsiveStyles: {
                large: {
                  color: "var(--color-swdc-orange-400, #ff6200)",
                  fontWeight: "var(--font-weight-bold, 700)",
                  textAlign: "center",
                },
              },
            },
            {
              "@type": "@builder.io/sdk:Element",
              component: {
                name: "Text",
                options: {
                  text: "<h2>One of our ITSM specialists will also reach out to discuss how we can help</h2>",
                },
              },
              responsiveStyles: {
                large: {
                  color: "var(--color-swdc-gray-400, #444444)",
                  textAlign: "center",
                },
              },
            },
            {
              "@type": "@builder.io/sdk:Element",
              component: {
                name: "ITSMPdfButtons",
              },
            },
          ],
        },
      ],
    },
  ],
};
